module.exports=require('../../decode-ranges.js')('JERAhjAZAxXeAwl-KcBEAguAw-fA')